const ZIPCODE_PATTERN = '(?=(?:.{5}|.{9})$)[0-9]*';
export const ZIPCODE_PATTERN_VALIDATION_MESSAGE =
  'Zip code must be exactly 5 digits.';
export const ZIPCODE_SHIPPING_VALIDATION_MESSAGE =
  'We only ship to mainland US, excluding Hawaii and Alaska.';

const EMAIL_PATTERN =
  '(([^<>\\(\\)\\[\\]\\.,;:\\s@"]+(\\.[^<>\\(\\)\\[\\]\\.,;:\\s@"]+)*)|(".+"))@(([^<>\\(\\)\\[\\]\\.,;:\\s@"]+\\.)+[^<>\\(\\)\\[\\]\\.,;:\\s@"]{2,})';
export const EMAIL_VALIDATION_MESSAGE = 'Please enter a valid email.';

export const VALIDATION = {
  zip: {
    pattern: {
      value: ZIPCODE_PATTERN,
      message: ZIPCODE_PATTERN_VALIDATION_MESSAGE,
    },
    invalid: { message: ZIPCODE_SHIPPING_VALIDATION_MESSAGE },
  },
  email: {
    pattern: {
      value: EMAIL_PATTERN,
      message: EMAIL_VALIDATION_MESSAGE,
    },
    invalid: { message: EMAIL_VALIDATION_MESSAGE },
  },
};

export const GENERIC_ERROR_MESSAGE = 'An error occurred.';
